"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GreatmindsLogoSquare_exports = {};
__export(GreatmindsLogoSquare_exports, {
  default: () => GreatmindsLogoSquare_default
});
module.exports = __toCommonJS(GreatmindsLogoSquare_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_45530_9595)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip1_45530_9595)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M39.3519 0C39.7098 0 40 0.290186 40 0.648148V39.3519C40 39.7098 39.7098 40 39.3519 40H0.648148C0.290186 40 0 39.7098 0 39.3519V0.648148C0 0.290186 0.290186 0 0.648148 0H39.3519ZM38.7037 1.2963H1.2963V38.7037H38.7037V1.2963ZM33.1571 21.2037C34.2962 21.2037 34.7272 21.868 34.8237 22.3878L33.91 22.6386C33.8778 22.4318 33.704 22.0809 33.1507 22.0809C32.7709 22.0809 32.5268 22.3128 32.5268 22.557C32.5268 22.7704 32.6617 22.9265 32.9769 22.9829L33.5885 23.0957C34.4569 23.2526 34.9074 23.7975 34.9074 24.4301C34.9074 25.1254 34.3089 25.8333 33.2214 25.8333C31.9604 25.8333 31.4198 25.0376 31.3555 24.4112L32.2886 24.1921C32.3271 24.5994 32.6101 24.9565 33.2345 24.9565C33.6333 24.9565 33.8778 24.7687 33.8778 24.4931C33.8778 24.2675 33.6909 24.1044 33.3885 24.048L32.7649 23.9355C31.9925 23.791 31.523 23.2901 31.523 22.632C31.523 21.7926 32.2819 21.2037 33.1571 21.2037ZM6.78863 21.298L8.04325 24.2988L9.23357 21.298H10.6299V25.7394H9.63285V22.7955L8.44214 25.7394H7.61856L6.42824 22.833V25.7394H5.46296V21.298H6.78863ZM14.7656 21.2976V25.7394H13.7361V21.2976H14.7656ZM19.0875 21.298L20.799 23.9981V21.298H21.8155V25.7394H20.7414L18.8625 22.8198V25.7394H17.8524V21.298H19.0875ZM26.5692 21.298C27.9397 21.298 28.8598 22.1497 28.8598 23.5216C28.8598 24.8939 27.9397 25.7394 26.5625 25.7394H24.9153V21.298H26.5692ZM26.5212 22.1434H25.9318V24.8511H26.5212C27.2188 24.8511 27.7881 24.4354 27.7881 23.5C27.7881 22.5651 27.2188 22.1434 26.5212 22.1434ZM7.69595 14.1667C9.02631 14.1667 9.64237 14.9187 9.8453 15.5386L8.84925 15.8709C8.77729 15.595 8.46926 15.0941 7.69595 15.0941C7.06695 15.0941 6.32638 15.4949 6.32638 16.4846C6.32638 17.412 6.96872 17.8939 7.72223 17.8939C8.48867 17.8939 8.81004 17.4182 8.86906 17.1678H7.47321V16.3281H9.83883V18.7024H9.00003L8.93454 18.2514C8.73121 18.5335 8.29261 18.7963 7.63046 18.7963C6.33932 18.7963 5.27778 17.8881 5.27778 16.4846C5.27778 15.0876 6.38499 14.1667 7.69595 14.1667ZM14.7447 14.261C15.6619 14.261 16.2521 14.8623 16.2521 15.6518C16.2521 16.2531 15.9045 16.7103 15.3345 16.9046L16.2784 18.7024H15.138L14.3057 17.0488H13.9386V18.7024H12.903V14.261H14.7447ZM22.1152 14.261V15.1942H20.208V16.0402H21.9386V16.9108H20.208V17.7629H22.1217V18.7024H19.1728V14.261H22.1152ZM27.6622 14.261L29.3924 18.7024H28.2654L27.9311 17.8004H26.1354L25.8011 18.7024H24.7133L26.4633 14.261H27.6622ZM35.0926 14.261V15.2066H33.6571V18.7024H32.6223V15.2066H31.1937V14.261H35.0926ZM27.0462 15.3355L26.4762 16.9494H27.6036L27.0462 15.3355ZM14.5274 15.135H13.9178V16.2686H14.5274C14.9531 16.2686 15.1827 16.0309 15.1827 15.7014C15.1827 15.3524 14.9531 15.135 14.5274 15.135Z",
      fill: "currentColor"
    }
  ))),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_45530_9595" }, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, fill: "white" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip1_45530_9595" }, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, fill: "white" })))
);
const SvgGreatmindsLogoSquare = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GreatmindsLogoSquare_default = SvgGreatmindsLogoSquare;
